export const helpers = {
  data() {
    return {
      tabs: ""
    };
  },
  methods: {
    to_slug(value) {
      if (value === undefined) {
        return "";
      }
      // if first number
      if (/^\d/.test(value)) {
        value = "x" + value;
      }
      return value
        .toString()
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/\s+/g, "-")
        .replace(/\„/g, "")
        .replace(/\”/g, "")
        .replace(/\,/g, "")
        .replace(/\:/g, "")
        .replace(/\//g, "")
        .replace(/\(/g, "")
        .replace(/\)/g, "")
        .replace(/\./g, "")
        .replace(/\%/g, "")
        .replace(/\+/g, "")
        .replace(/\~/g, "")
        .toLowerCase();
    },
    slash_to_comma(value) {
      if (value === undefined) {
        return "";
      }
      return value.toString().replace(/\//g, ",");
    },
    slash_to_double_comma(value) {
      if (value === undefined) {
        return "";
      }
      return value.toString().replace(/\//g, ",,");
    },
    podmien (napis)
    {
      napis=napis.replace("ę","e");
      napis=napis.replace("ó","o");
      napis=napis.replace("ą","a");
      napis=napis.replace("ś","s");
      napis=napis.replace("ł","l");
      napis=napis.replace("ż","z");
      napis=napis.replace("ź","z");
      napis=napis.replace("ć","c");
      napis=napis.replace("ń","n");

      napis=napis.replaceAll('[', '');
      napis=napis.replaceAll(']', '');
      napis=napis.replaceAll(' ', '_');

      return napis;
    },
    download(elem) {
      this.tabs = elem;
      let products_request = [];
      let strProducts = "";
      let strPrices = "";

      let sessionListType = (sessionStorage.getItem("listType")) ? sessionStorage.getItem("listType") : 'pulsar';
      console.log("download: " + this.tabs);

      if ("sales" == elem) {
        products_request = this.sales_products_uniq;
      } else if ("rises" == elem) {
        products_request = this.rises_products_uniq;
      } else if ("reductions" == elem) {
        products_request = this.reductions_products_uniq;
      } else if ("news" == elem) {
        products_request = this.news_products_uniq;
      } else if ("phone" == elem) {
        products_request = this.phone_products_uniq;
      } else if ("promotions" == elem) {
        products_request = this.promotions_products_uniq;
      }

      for (var i = 0; i < products_request.length; i++) {
        strProducts += products_request[i].product_id + ",";
        strPrices += products_request[i].data.price.netto + ",";
      }

      let url =
        this.axios.defaults.baseURL +
        "pricelist/tabs?products[]=" +
        strProducts +
        "&prices[]=" +
        strPrices +
        "&lang=" +
        this.$i18n.locale +
        "&tab=" +
        elem +
        "&company=" +
        sessionListType;
      window.open(url);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixins/helpers.js